<div class="container">
  @if (mapLoaded) {
    <google-map
      [height]="'400px'"
      [width]="'100%'"
      [center]="center"
      [zoom]="zoom">
      @for (m of markers; track m; let i = $index) {
        <map-marker
          [position]="{ lat: m.lat, lng: m.lng }"
          [title]="m.title"
          (mapClick)="openInfoWindow(i)">
          <map-info-window>Store: {{ m.title }}</map-info-window>
        </map-marker>
      }
    </google-map>
  }
  @if (!mapLoaded) {
    <div class="map-loading">{{ 'Loading map...' | translate }}</div>
  }
</div>
